import actions from './actions'
import mutations from './mutations'

const glossary = {
  namespaced: true,
  state: {
    exhibitionGroups: [],
    countries: [],
    exhib_groups: [],
    loading: true,
    error: null
  },
  mutations: mutations,
  actions: actions
}

export default glossary



// WEBPACK FOOTER //
// ./src/store/glossary/index.js